/* Keuringssticker-studio (Taak 5, projecten/keuringsstickers-studio/thema/)
 *
 * Eén object met een state en een teken()-functie die alles opnieuw
 * opbouwt, zoals de taakbrief vraagt. Geen build-stap, geen framework: dit
 * draait direct in het thema via een <script defer>.
 */
(function () {
  "use strict";

  // Canvas is altijd 600x600 in logische pixels; devicePixelRatio-schaling
  // gebeurt in initCanvas(). Alle tekencode hieronder rekent in dat
  // logische 600x600-vlak, ongeacht scherm-dpi of CSS-weergavegrootte.
  var CANVAS_MAAT = 600;

  // Verhoudingen t.o.v. de canvasbreedte, gemeten op de echte
  // ondergrond-JPEG's (1200x1200): sluitrand van de sticker (Weblaag) op
  // r=575. Zie taak-5-rapport.md voor de meting.
  //
  // Eindfixronde, CRITICAL 2: MIDDENVLAK_*_FRACTIE was afgeleid uit een
  // pixelmeting op de JPEG (19,17 mm-equivalent) die achteraf niet klopte
  // met de echte, in Illustrator gemeten middenvlak-diameter die
  // maak_drukbestanden.py/drukbestand.jsx gebruiken: MIDDENVLAK_DIAM_MM =
  // 20,19 mm. Nu afgeleid van diezelfde 20,19 mm, via dezelfde
  // mm->px-schaal als de fontgroottes hieronder (STICKER_DIAMETER_FRACTIE
  // x CANVAS_MAAT px komt overeen met STICKER_DIAM_MM mm), zodat de
  // preview-clipcirkel en de druk-clipcirkel identiek kaderen.
  var STICKER_DIAM_MM = 35.0; // zelfde gemeten waarde als maak_drukbestanden.py
  var MIDDENVLAK_DIAM_MM = 20.19; // zelfde gemeten waarde als maak_drukbestanden.py
  var STICKER_RADIUS_FRACTIE = 0.4792;
  var STICKER_DIAMETER_FRACTIE = 0.9583;
  var MIDDENVLAK_RADIUS_FRACTIE = (STICKER_DIAMETER_FRACTIE * (MIDDENVLAK_DIAM_MM / 2)) / STICKER_DIAM_MM;
  var MIDDENVLAK_BREEDTE_FRACTIE = (STICKER_DIAMETER_FRACTIE * MIDDENVLAK_DIAM_MM) / STICKER_DIAM_MM;

  // Fix 2026-08-23 (melding Richard: wit logo dekte de zwarte scheidingscirkel
  // af). De dunne zwarte cirkel op de middenvlak-rand zit in 999.ai in de
  // JAARLAAG (1 pt-lijn op de 20,19mm-cirkel), en de druk zet de logolaag
  // ONDER die jaarlaag (drukbestand.jsx stap 2): daar drukt de cirkel dus al
  // over het logo heen. De preview tekent het logo echter bovenop de PLATTE
  // ondergrond-JPEG, waardoor het logo de cirkel afdekte. Daarom tekent
  // herstelScheidingscirkel() na het logo de ondergrond terug, overal BUITEN
  // de binnenrand van die cirkel. Binnenrand gemeten op een 4000px-render van
  // 999.ai (zie sessielog 2026-08-23): de cirkelband beslaat r=1079..1116 van
  // 4000 = fractie 0.26975..0.279 van de paginabreedte, en de JPEG's vullen
  // het canvas precies (zelfde vierkante pagina), dus die fractie geldt hier
  // 1-op-1. Niet afgeleid van MIDDENVLAK_RADIUS_FRACTIE: die rekent via de
  // 575px=35mm-aanname en zit daardoor een fractie te ver naar buiten,
  // precies genoeg om de cirkel grotendeels af te dekken.
  var SCHEIDING_BINNENRAND_FRACTIE = 0.26975;

  // Eindfixronde, CRITICAL 1 (ruling: de DRUK is leidend, tekstgrootte
  // gelijk aan de bestaande productiestickers): drukbestand.jsx zet
  // keuringstekst op 9 pt en tekst boven/rechts van het logo op 5 pt. Op
  // dit 600px-canvas is de stickerdiameter (STICKER_DIAMETER_FRACTIE x
  // CANVAS_MAAT = 575 px) gelijk aan STICKER_DIAM_MM (35 mm), dus
  // 1 pt = (1/72 inch = 25,4/72 mm) x (575/35) px = ~5,80 px. 9 pt -> ~52
  // px, 5 pt -> ~29 px. Bereken dit uit dezelfde constanten i.p.v. losse
  // magic numbers, zodat een toekomstige aanpassing van de gemeten maten
  // vanzelf doorwerkt in de startgrootte.
  var PX_PER_PT = ((STICKER_DIAMETER_FRACTIE * CANVAS_MAAT) / STICKER_DIAM_MM) * (25.4 / 72);
  // Taak 7 (ruling: druk leidend voor tekst-rechts-plaatsing): px-per-mm op
  // dezelfde mm-rekenbasis als PX_PER_PT hierboven (575 px = 35 mm), nodig
  // voor de Pythagoras-ondergrens van 6 mm in tekenLogoTeksten(), analoog
  // aan drukbestand.jsx regel 275-283 (var MM = 2.834645669291339 daar).
  var PX_PER_MM = (STICKER_DIAMETER_FRACTIE * CANVAS_MAAT) / STICKER_DIAM_MM;
  var KEURINGSTEKST_PT = 9;
  var LOGOTEKST_PT = 5;
  var KEURINGSTEKST_START_PX = Math.round(KEURINGSTEKST_PT * PX_PER_PT); // ~52
  var LOGOTEKST_START_PX = Math.round(LOGOTEKST_PT * PX_PER_PT); // ~29
  // Regelhoogte tussen keuringstekst-regels: was hard 1,25x de fontgrootte
  // (drukbestand.jsx: lijnHoogte = keuringstekstSizePt * 1.25), sinds
  // verbetering B is 1,25 de DEFAULT van het schuifje "Regelafstand"
  // (state.regelafstand) i.p.v. een vaste constante -- zie
  // berekenKeuringstekstGrootte()/tekenKeuringstekst() hieronder.

  // --- Contract _LogoPositie (fixronde 1, bevinding 3 -- controller-ruling,
  // taak 6 parseert dit LETTERLIJK, dus deze definitie exact aanhouden) ---
  //
  // x en y in de winkelwagen-property zijn het MIDDELPUNT van het logo,
  // relatief aan het STICKERVLAK: 0..1 over de stickerdiameter, oorsprong
  // linksboven van het vierkant dat de stickercirkel omsluit (dus NIET
  // canvas-relatief en NIET middenvlak-relatief). schaal blijft logobreedte
  // gedeeld door stickerdiameter (dat is al hoe state.logoPos.schaal intern
  // gedefinieerd is, zie logoRechthoek(), dus die hoeft niet omgerekend te
  // worden). state.logoPos.x/y zelf blijven intern canvas-relatief (0..1
  // over CANVAS_MAAT) -- makkelijker voor tekenen/klemmen/slepen -- en
  // worden pas omgerekend naar het stickervlak-contract op het moment dat
  // we naar de property schrijven, zie logoPositieVoorProperty() hieronder.

  // --- Contract _TekstPositie (verbetering A, zelfde conventie als
  // _LogoPositie hierboven; uitgebreid in verbetering B met grootte/
  // regelafstand) ---
  //
  // y in de winkelwagen-property is het MIDDELPUNT van het keuringstekst-blok
  // (de 1-3 regels samen), relatief aan het STICKERVLAK: 0..1 over de
  // stickerdiameter, zelfde oorsprong als _LogoPositie (linksboven van het
  // vierkant om de stickercirkel). Alleen y, geen x: het blok blijft altijd
  // horizontaal gecentreerd en mag alleen VERTICAAL verschuiven. Default 0.5
  // is de oude vaste positie (het canvasmidden, exact zoals voor deze
  // verbetering al vaststond) -- op het stickervlak-contract wordt dat ook
  // 0.5 (het stickermidden valt samen met het canvasmidden), dus orders
  // zonder slepen blijven identiek. Net als bij logoPos blijft
  // state.tekstPos.y intern canvas-relatief (0..1 over CANVAS_MAAT) en wordt
  // pas omgerekend bij het wegschrijven naar de winkelwagen-property, zie
  // tekstPositieVoorProperty() hieronder. De teksten boven/rechts van het
  // logo blijven gewoon aan het logo gekoppeld (logoRechthoek()), die krijgen
  // geen eigen positie.
  //
  // Verbetering B (2026-08-22, twee nieuwe schuifjes "Tekstgrootte" en
  // "Regelafstand"): _TekstPositie kreeg er twee velden bij, allebei
  // factoren (geen graden/pixels, zodat druk en preview onafhankelijk van
  // canvas-/mm-schaal dezelfde waarde toepassen):
  //   grootte      - 0.5..1.5, 1.0 = de bestaande basisgrootte (9 pt druk /
  //                  KEURINGSTEKST_START_PX preview). state.tekstGrootte.
  //   regelafstand - 1.0..2.0, standaard 1.25 (de bestaande, hard gecodeerde
  //                  regelhoogte-factor van voor dit schuifje). state.regelafstand.
  // ALLE regels krijgen dezelfde grootte (zie berekenKeuringstekstGrootte()):
  // niet langer per regel krimpen zoals voorheen (pasFontToe() deed dat nog
  // per regel), de krimpfactor wordt nu bepaald over de LANGSTE regel en
  // daarna op het hele blok toegepast. Het automatisch krimpen blijft alleen
  // over als vangnet (grootte-schuifje te hoog + lange tekst): komt de
  // langste regel breder dan de bestaande 70%-grens van het middenvlak, dan
  // krimpt het hele blok tot de langste regel precies past. drukbestand.jsx
  // past exact dezelfde formule toe (TEKST_GROOTTE/TEKST_REGELAFSTAND op de
  // 9pt-basis), zodat preview en druk blijven spiegelen. Ontbreken deze twee
  // velden (oude orders/snapshots van voor dit schuifje), dan vallen
  // maak_drukbestanden.py en drukbestand.jsx terug op dezelfde defaults
  // (1.0 / 1.25) als hier, dus bestaande orders drukken identiek.

  var state = {
    kleur: "blauw",
    reeks: "26-32",
    teksten: ["", "", ""],
    tekstBoven: "",
    tekstRechts: "",
    logoImg: null,
    logoUrl: null,
    logoBezigMetUploaden: false,
    // Eindfixronde, meelifter: aparte vlag naast logoBezigMetUploaden. Een
    // logo-upload die precies klaarkomt terwijl de klant al op "In
    // winkelwagen" heeft geklikt (snapshot maken/uploaden, cart/add.js)
    // mocht de bestelknop niet weer vrijgeven middenin die verzending --
    // zie bijwerkenToevoegenKnopStatus().
    bezigMetVerzenden: false,
    logoPos: { x: 0.5, y: 0.62, schaal: 0.4 },
    tekstPos: { y: 0.5 },
    // Verbetering B: schuifjes "Tekstgrootte" en "Regelafstand", zie het
    // _TekstPositie-contract hierboven. Defaults zijn de oude, vaste waarden
    // (100% grootte, 125% regelafstand) zodat een preview zonder aan de
    // schuifjes te komen er identiek uitziet als voor deze verbetering.
    tekstGrootte: 1.0,
    regelafstand: 1.25,
    snapshotUrl: null,
  };

  var ondergronden = {}; // "blauw-26-32" -> Image, lazy geladen

  var canvas, ctx;
  var slepen = null; // { dx, dy } offset t.o.v. logocentrum tijdens pointerdown

  function ondergrondUrl(kleur, reeks) {
    var key = kleur + "-" + reeks;
    return (window.STUDIO_ASSET_URLS && window.STUDIO_ASSET_URLS[key]) || "";
  }

  function laadOndergrond(kleur, reeks, klaar, forceerVers) {
    var key = kleur + "-" + reeks;
    if (ondergronden[key]) {
      klaar(ondergronden[key]);
      return;
    }
    var url = ondergrondUrl(kleur, reeks);
    if (!url) {
      return;
    }
    if (forceerVers) {
      // Herprobeer-knop (bevinding 6): zonder cache-buster onthoudt de
      // browser de mislukte fetch voor exact deze URL en probeert bij een
      // simpele retry het netwerk niet eens opnieuw, dus de melding zou
      // nooit verdwijnen ook al is de verbinding intussen hersteld.
      url += (url.indexOf("?") === -1 ? "?" : "&") + "_herprobeer=" + Date.now();
    }
    var img = new Image();
    // Nodig zodat canvas.toBlob() in stap 6 geen "tainted canvas" geeft,
    // ook als de ondergrond ooit via een echt cross-origin CDN-pad komt
    // (de Shopify-CDN stuurt access-control-allow-origin: *, dus dit kost
    // niets als de afbeelding toch al same-origin blijkt).
    img.crossOrigin = "anonymous";
    img.onload = function () {
      ondergronden[key] = img;
      toonCanvasFoutmelding(null);
      klaar(img);
    };
    // Fixronde 1, bevinding 6: zonder onerror bleef de canvas stil grijs
    // (teken() stopt vroeg als de ondergrond er nog niet is, en zonder
    // fout komt er nooit een tweede teken()-aanroep). Toon nu een
    // zichtbare melding met een herprobeer-knop (zie initGebeurtenissen).
    img.onerror = function () {
      toonCanvasFoutmelding(
        "De afbeelding voor deze kleur/jaarreeks kon niet geladen worden. " +
          "Controleer je verbinding en probeer het opnieuw."
      );
    };
    img.src = url;
  }

  function toonCanvasFoutmelding(tekst) {
    var el = document.getElementById("studio-canvas-fout");
    var tekstEl = document.getElementById("studio-canvas-fout-tekst");
    if (!el || !tekstEl) {
      return;
    }
    if (!tekst) {
      el.hidden = true;
      return;
    }
    tekstEl.textContent = tekst;
    el.hidden = false;
  }

  function stickerDiameterPx() {
    return STICKER_DIAMETER_FRACTIE * CANVAS_MAAT;
  }

  function stickerRadiusPx() {
    return STICKER_RADIUS_FRACTIE * CANVAS_MAAT;
  }

  function middenvlakBreedtePx() {
    return MIDDENVLAK_BREEDTE_FRACTIE * CANVAS_MAAT;
  }

  // --- Tekenen -------------------------------------------------------

  function teken() {
    if (!ctx) {
      return;
    }
    ctx.clearRect(0, 0, CANVAS_MAAT, CANVAS_MAAT);

    var key = state.kleur + "-" + state.reeks;
    var ondergrond = ondergronden[key];
    if (ondergrond) {
      ctx.drawImage(ondergrond, 0, 0, CANVAS_MAAT, CANVAS_MAAT);
    } else {
      ctx.fillStyle = "#eeeeee";
      ctx.fillRect(0, 0, CANVAS_MAAT, CANVAS_MAAT);
      laadOndergrond(state.kleur, state.reeks, teken);
      return;
    }

    // Eindfixronde, IMPORTANT 3 (ruling: overal TEKST BOVEN LOGO): de druk
    // tekent de teksten al bovenop het logo (Studio Tekst-laag komt na de
    // Logo-laag, zie drukbestand.jsx). Hier eerst het logo, dan pas de
    // teksten, zodat de canvas-tekenvolgorde (laatst getekend = bovenop)
    // hetzelfde resultaat geeft als de druk en de snapshot. De
    // scheidingscirkel komt daartussenin: boven het logo (zoals de jaarlaag
    // in de druk), maar onder de teksten (de Studio Tekst-laag ligt in de
    // druk helemaal bovenop, en "tekst rechts" mag bewust de ring inlopen).
    tekenLogo();
    herstelScheidingscirkel(ondergrond);
    tekenKeuringstekst();
    tekenLogoTeksten();
  }

  // Fix 2026-08-23 (zie SCHEIDING_BINNENRAND_FRACTIE bovenin): tekent de
  // ondergrond opnieuw, geclipt op alles BUITEN de binnenrand van de zwarte
  // scheidingscirkel. Daarmee komt de cirkel (en alles daarbuiten) weer
  // bovenop het logo te liggen, exact zoals de druk stapelt. De snapshot
  // volgt vanzelf, die tekent via dezelfde teken()-functie.
  function herstelScheidingscirkel(ondergrond) {
    if (!state.logoImg) {
      return; // zonder logo valt er niets te herstellen
    }
    var midden = CANVAS_MAAT / 2;
    ctx.save();
    ctx.beginPath();
    ctx.rect(0, 0, CANVAS_MAAT, CANVAS_MAAT);
    // Cirkel TEGENWIJZER in hetzelfde pad: met de standaard nonzero-vulregel
    // heffen de windingrichtingen elkaar binnen de cirkel op, dus de clip
    // wordt een rechthoek met een rond gat erin.
    ctx.arc(midden, midden, SCHEIDING_BINNENRAND_FRACTIE * CANVAS_MAAT, 0, Math.PI * 2, true);
    ctx.clip();
    ctx.drawImage(ondergrond, 0, 0, CANVAS_MAAT, CANVAS_MAAT);
    ctx.restore();
  }

  function pasFontToe(tekst, maxBreedte, startGrootte, minGrootte) {
    var grootte = startGrootte;
    ctx.font = "bold " + grootte + "px Arial";
    while (ctx.measureText(tekst).width > maxBreedte && grootte > minGrootte) {
      grootte -= 1;
      ctx.font = "bold " + grootte + "px Arial";
    }
    return grootte;
  }

  // Verbetering B: bepaalt de EEN grootte (in px) die voor het HELE
  // keuringstekst-blok geldt -- niet langer per regel (dat was pasFontToe()
  // hierboven, die krimpt regel voor regel en liet daardoor een korte regel
  // reusachtig groot en een lange regel klein staan). Basis is
  // KEURINGSTEKST_START_PX * state.tekstGrootte (het schuifje "Tekstgrootte",
  // 50%-150%). Het automatisch krimpen blijft daarna alleen nog als vangnet:
  // is de LANGSTE regel op die grootte breder dan de bestaande 70%-grens van
  // het middenvlak, dan krimpt de hele basisgrootte (dus alle regels
  // tegelijk, dezelfde krimpfactor) tot de langste regel precies past.
  // Dezelfde formule (basis x min(1, maxBreedte/langsteBreedte)) staat ook
  // in drukbestand.jsx, zodat preview en druk exact spiegelen.
  function berekenKeuringstekstGrootte(regels) {
    var basisGrootte = KEURINGSTEKST_START_PX * state.tekstGrootte;
    var maxBreedte = middenvlakBreedtePx() * 0.7;

    ctx.font = "bold " + basisGrootte + "px Arial";
    var langsteBreedte = 0;
    for (var i = 0; i < regels.length; i++) {
      var breedte = ctx.measureText(regels[i]).width;
      if (breedte > langsteBreedte) {
        langsteBreedte = breedte;
      }
    }
    if (langsteBreedte > maxBreedte && langsteBreedte > 0) {
      basisGrootte = basisGrootte * (maxBreedte / langsteBreedte);
    }
    // Defensief ondergrens, zelfde geest als de oude minGrootte=8 van
    // pasFontToe(): nooit 0 of negatief, ook niet bij een extreem lange regel.
    return Math.max(basisGrootte, 1);
  }

  function tekenKeuringstekst() {
    var regels = state.teksten.filter(function (t) {
      return t && t.trim() !== "";
    });
    if (regels.length === 0) {
      return;
    }

    var tekstKleur = state.kleur === "rood" ? "#ffffff" : "#000000";
    var grootte = berekenKeuringstekstGrootte(regels);
    var regelHoogte = grootte * state.regelafstand;
    var totaleHoogte = regels.length * regelHoogte;
    // Verbetering A: het blok is niet langer canvas-vast op het midden,
    // maar gecentreerd op state.tekstPos.y (versleepbaar, geklemd in
    // klemTekstPositie()). Default 0.5 geeft exact de oude vaste positie.
    var middenY = state.tekstPos.y * CANVAS_MAAT;
    var startY = middenY - totaleHoogte / 2 + regelHoogte / 2;

    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = tekstKleur;
    ctx.font = "bold " + grootte + "px Arial";

    for (var i = 0; i < regels.length; i++) {
      ctx.fillText(regels[i], CANVAS_MAAT / 2, startY + i * regelHoogte);
    }
  }

  function logoRechthoek() {
    var breedte = state.logoPos.schaal * stickerDiameterPx();
    var hoogte = breedte;
    if (state.logoImg && state.logoImg.naturalWidth) {
      hoogte = (breedte * state.logoImg.naturalHeight) / state.logoImg.naturalWidth;
    }
    var cx = state.logoPos.x * CANVAS_MAAT;
    var cy = state.logoPos.y * CANVAS_MAAT;
    return { cx: cx, cy: cy, breedte: breedte, hoogte: hoogte };
  }

  function tekenLogoTeksten() {
    // Eindfixronde, IMPORTANT 4 (spookteksten): zonder logo bestaat er geen
    // logoRechthoek() om deze twee teksten tegenaan te positioneren, en de
    // druk drukt ze dan ook niet (drukbestand.jsx: "if (LOGO_HEEFT && ...)").
    // Zonder deze guard tekende de preview ze toch, op de spookpositie van
    // de default logoPos.
    if (!state.logoImg) {
      return;
    }
    var rechthoek = logoRechthoek();
    var tekstKleur = state.kleur === "rood" ? "#ffffff" : "#000000";
    ctx.fillStyle = tekstKleur;

    if (state.tekstBoven && state.tekstBoven.trim() !== "") {
      ctx.textAlign = "center";
      ctx.textBaseline = "bottom";
      // Eindfixronde 2: exact dezelfde maxbreedte als drukbestand.jsx regel
      // 324 (verkleinIndienNodig(tfB, middenvlakBreedtePt * 0.9)) i.p.v. de
      // logo-breedte. Die twee liepen uiteen: bij een klein logo liet de
      // preview "tekst boven logo" veel groter staan dan de druk toeliet,
      // waardoor het optionele veld in preview en druk niet even groot toonde.
      pasFontToe(state.tekstBoven, middenvlakBreedtePx() * 0.9, LOGOTEKST_START_PX, 8);
      ctx.fillText(state.tekstBoven, rechthoek.cx, rechthoek.cy - rechthoek.hoogte / 2 - 6);
    }

    if (state.tekstRechts && state.tekstRechts.trim() !== "") {
      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      // Taak 7 (gevonden in de eindfixronde, zie taak-7-rapport.md): exact
      // dezelfde Pythagoras-formule als drukbestand.jsx regel 275-283, tegen
      // de rand van de middenvlak-cirkel op logohoogte, met dezelfde
      // ondergrens van 6 mm die bewust de ring in mag lopen. Zonder dit liep
      // "tekst rechts" bij een groot logo in de preview gewoon door tot een
      // vaste breedte van 140 px, terwijl de druk daar al had ingekrompen --
      // preview en druk plaatsen deze tekst nu identiek.
      var halveMiddenvlak = middenvlakBreedtePx() / 2;
      var dyMidden = rechthoek.cy - CANVAS_MAAT / 2;
      var beschikbareHalf = Math.sqrt(Math.max(0, halveMiddenvlak * halveMiddenvlak - dyMidden * dyMidden));
      var logoRechterrand = rechthoek.cx + rechthoek.breedte / 2;
      var beschikbareBreedteR = Math.max(6 * PX_PER_MM, (CANVAS_MAAT / 2 + beschikbareHalf) - logoRechterrand);
      pasFontToe(state.tekstRechts, beschikbareBreedteR, LOGOTEKST_START_PX, 8);
      ctx.fillText(state.tekstRechts, logoRechterrand + 8, rechthoek.cy);
    }
  }

  function tekenLogo() {
    if (!state.logoImg) {
      return;
    }
    var rechthoek = logoRechthoek();
    var midden = CANVAS_MAAT / 2;
    var middenvlakRadiusPx = MIDDENVLAK_RADIUS_FRACTIE * CANVAS_MAAT;

    // Ontwerpbeslissing Richard (2026-08-22): het logo schuift ONDER de
    // rand met de maand- en jaarcijfers. Clip het tekenen op de
    // middenvlak-cirkel, zodat het stuk dat over de rand geschoven wordt
    // verdwijnt onder de rand en de cijfers altijd leesbaar blijven.
    // Slepen blijft vrij (de bestaande klem op de hele stickercirkel in
    // klemLogoPositie() verandert niet), alleen het tekenen wordt hier
    // begrensd. De snapshot volgt vanzelf, want die tekent via dezelfde
    // teken()-functie.
    ctx.save();
    ctx.beginPath();
    ctx.arc(midden, midden, middenvlakRadiusPx, 0, Math.PI * 2);
    ctx.clip();
    ctx.drawImage(
      state.logoImg,
      rechthoek.cx - rechthoek.breedte / 2,
      rechthoek.cy - rechthoek.hoogte / 2,
      rechthoek.breedte,
      rechthoek.hoogte
    );
    ctx.restore();
  }

  // --- Logo klemmen binnen de stickercirkel ---------------------------

  function klemLogoPositie() {
    var rechthoek = logoRechthoek();
    var halveDiagonaal = Math.sqrt(
      Math.pow(rechthoek.breedte / 2, 2) + Math.pow(rechthoek.hoogte / 2, 2)
    );
    var maxAfstand = Math.max(stickerRadiusPx() - halveDiagonaal, 0);
    var midden = CANVAS_MAAT / 2;
    var dx = rechthoek.cx - midden;
    var dy = rechthoek.cy - midden;
    var afstand = Math.sqrt(dx * dx + dy * dy);
    if (afstand > maxAfstand && afstand > 0) {
      var factor = maxAfstand / afstand;
      state.logoPos.x = (midden + dx * factor) / CANVAS_MAAT;
      state.logoPos.y = (midden + dy * factor) / CANVAS_MAAT;
    }
  }

  // Rekent een intern canvas-relatieve fractie (0..1 over CANVAS_MAAT) om
  // naar het stickervlak-contract dat _LogoPositie en _TekstPositie allebei
  // gebruiken: 0..1 over de stickerdiameter, oorsprong linksboven van het
  // vierkant om de stickercirkel. Gedeeld door logoPositieVoorProperty()
  // (x en y) en tekstPositieVoorProperty() (alleen y) hieronder.
  function canvasFractieNaarStickervlak(canvasFractie) {
    var stickerLinksBoven = CANVAS_MAAT / 2 - stickerRadiusPx();
    var diameter = stickerDiameterPx();
    var canvasPx = canvasFractie * CANVAS_MAAT;
    return afronden2((canvasPx - stickerLinksBoven) / diameter);
  }

  // Rekent de intern canvas-relatieve state.logoPos om naar het contract
  // uit taak 2/3 (zie de toelichting hierboven bij de fractie-constanten):
  // x/y als middelpunt van het logo, 0..1 over de stickerdiameter, oorsprong
  // linksboven van het vierkant om de stickercirkel. Alleen gebruikt op het
  // moment van wegschrijven naar de winkelwagen-property.
  function logoPositieVoorProperty() {
    return {
      x: canvasFractieNaarStickervlak(state.logoPos.x),
      y: canvasFractieNaarStickervlak(state.logoPos.y),
      schaal: afronden2(state.logoPos.schaal),
    };
  }

  // --- Keuringstekst-blok klemmen binnen het middenvlak (verbetering A) --

  // Puur de blokhoogte in canvas-pixels van de huidige keuringstekst
  // (1-3 regels), 0 als er geen keuringstekst is. Gedeeld door
  // tekenKeuringstekst() (om te tekenen), tekstRechthoek() (hit-test/slepen)
  // en klemTekstPositie() (de klem), zodat alle drie exact dezelfde maat
  // aanhouden. Verbetering B: rekent met de actuele (mogelijk geschaalde
  // en/of gekrompen) grootte via berekenKeuringstekstGrootte() i.p.v. de
  // oude vaste KEURINGSTEKST_REGELHOOGTE_PX-constante, anders zou de klem
  // een ouder, te klein of te groot blok aanhouden zodra de schuifjes
  // bewegen.
  function tekstBlokHoogtePx() {
    var regels = state.teksten.filter(function (t) {
      return t && t.trim() !== "";
    });
    if (regels.length === 0) {
      return 0;
    }
    var grootte = berekenKeuringstekstGrootte(regels);
    return regels.length * grootte * state.regelafstand;
  }

  function tekstRechthoek() {
    return {
      cx: CANVAS_MAAT / 2,
      cy: state.tekstPos.y * CANVAS_MAAT,
      breedte: middenvlakBreedtePx() * 0.7,
      hoogte: tekstBlokHoogtePx(),
    };
  }

  function puntInTekstblok(punt) {
    if (tekstBlokHoogtePx() === 0) {
      return false;
    }
    var rechthoek = tekstRechthoek();
    return (
      punt.x >= rechthoek.cx - rechthoek.breedte / 2 &&
      punt.x <= rechthoek.cx + rechthoek.breedte / 2 &&
      punt.y >= rechthoek.cy - rechthoek.hoogte / 2 &&
      punt.y <= rechthoek.cy + rechthoek.hoogte / 2
    );
  }

  // Het keuringstekst-blok mag alleen VERTICAAL verschuiven (x blijft altijd
  // horizontaal gecentreerd), geklemd binnen de middenvlak-cirkel zodat het
  // nooit onder de cijferrand verdwijnt. Analoog aan klemLogoPositie()
  // hierboven, maar met de middenvlak-radius i.p.v. de volle stickerradius:
  // het logo mag tot de stickerrand (en clipt daar visueel), de
  // keuringstekst hoort altijd binnen de cijferring te blijven staan.
  function klemTekstPositie() {
    var halveHoogte = tekstBlokHoogtePx() / 2;
    var middenvlakRadiusPx = MIDDENVLAK_RADIUS_FRACTIE * CANVAS_MAAT;
    var maxAfstand = Math.max(middenvlakRadiusPx - halveHoogte, 0);
    var midden = CANVAS_MAAT / 2;
    var dy = state.tekstPos.y * CANVAS_MAAT - midden;
    if (Math.abs(dy) > maxAfstand) {
      var richting = dy < 0 ? -1 : 1;
      state.tekstPos.y = (midden + richting * maxAfstand) / CANVAS_MAAT;
    }
  }

  // _TekstPositie-contract (verbetering A/B, zie de toelichting bovenin dit
  // bestand): y = middelpunt (het blok blijft horizontaal gecentreerd),
  // grootte/regelafstand = de factoren van de twee schuifjes, letterlijk
  // state.tekstGrootte/state.regelafstand (geen stickervlak-omrekening nodig,
  // dat zijn al schaalfactoren, geen posities).
  function tekstPositieVoorProperty() {
    return {
      y: canvasFractieNaarStickervlak(state.tekstPos.y),
      grootte: afronden2(state.tekstGrootte),
      regelafstand: afronden2(state.regelafstand),
    };
  }

  // --- Uploaden --------------------------------------------------------

  function uploadBestand(bestand, opSucces, opFout) {
    var fd = new FormData();
    fd.append("bestand", bestand, bestand.name || "snapshot.png");
    fetch(window.STUDIO_UPLOAD_URL, { method: "POST", body: fd })
      .then(function (resp) {
        return resp.json().then(function (data) {
          return { ok: resp.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          opFout((result.data && result.data.fout) || "Uploaden is mislukt, probeer het nog eens.");
          return;
        }
        opSucces(result.data.url);
      })
      .catch(function () {
        opFout("Uploaden is mislukt, probeer het nog eens.");
      });
  }

  // --- Init + events -----------------------------------------------------

  function initCanvasHiDPI() {
    var dpr = window.devicePixelRatio || 1;
    canvas.width = CANVAS_MAAT * dpr;
    canvas.height = CANVAS_MAAT * dpr;
    ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);
  }

  function pointerNaarCanvas(evt) {
    var rect = canvas.getBoundingClientRect();
    return {
      x: ((evt.clientX - rect.left) * CANVAS_MAAT) / rect.width,
      y: ((evt.clientY - rect.top) * CANVAS_MAAT) / rect.height,
    };
  }

  function puntInLogo(punt) {
    var rechthoek = logoRechthoek();
    return (
      punt.x >= rechthoek.cx - rechthoek.breedte / 2 &&
      punt.x <= rechthoek.cx + rechthoek.breedte / 2 &&
      punt.y >= rechthoek.cy - rechthoek.hoogte / 2 &&
      punt.y <= rechthoek.cy + rechthoek.hoogte / 2
    );
  }

  function toonLogoStatus(tekst, isFout) {
    var el = document.getElementById("studio-logo-status");
    if (!el) {
      return;
    }
    el.textContent = tekst || "";
    el.classList.toggle("is-fout", !!isFout);
  }

  // Eindfixronde, IMPORTANT 4: de twee invoervelden voor "tekst boven/rechts
  // van het logo" staan uit (met een uitlegtekst in de liquid-template)
  // zolang er geen logo staat, zodat een klant niet per ongeluk tekst
  // typt die dan als spooktekst in de preview verschijnt maar nooit gedrukt
  // wordt. Zelfde voorwaarde (state.logoImg) als de tekenLogoTeksten()-guard.
  function bijwerkenLogoTekstVeldenStatus() {
    var heeftLogo = !!state.logoImg;
    ["studio-tekst-boven", "studio-tekst-rechts"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        el.disabled = !heeftLogo;
      }
    });
  }

  function kiesLogoBestand(bestand) {
    var lokaalUrl = URL.createObjectURL(bestand);
    var img = new Image();
    img.onload = function () {
      state.logoImg = img;
      klemLogoPositie();
      bijwerkenLogoTekstVeldenStatus();
      teken();
    };
    img.src = lokaalUrl;

    state.logoBezigMetUploaden = true;
    bijwerkenToevoegenKnopStatus();
    toonLogoStatus("Bezig met uploaden...");
    uploadBestand(
      bestand,
      function (url) {
        state.logoUrl = url;
        state.logoBezigMetUploaden = false;
        bijwerkenToevoegenKnopStatus();
        toonLogoStatus("Logo geupload.");
      },
      function (fout) {
        state.logoBezigMetUploaden = false;
        bijwerkenToevoegenKnopStatus();
        toonLogoStatus(fout, true);
      }
    );
  }

  // Fixronde 1, bevinding 2: state.logoBezigMetUploaden werd al gezet maar
  // nergens gelezen, dus een klant die net een logo koos kon meteen
  // bestellen voor de upload klaar was (order met lege _LogoURL, terwijl de
  // snapshot het logo wel toont). De bestelknop blokkeren zolang de upload
  // loopt, en weer vrijgeven zodra die klaar is (gelukt of mislukt).
  //
  // Eindfixronde, meelifter: OR met state.bezigMetVerzenden. Zonder die
  // vlag kon een logo-upload die precies klaarkomt TERWIJL de klant al op
  // "In winkelwagen" heeft geklikt (deze functie wordt dan ook aangeroepen
  // vanuit de success/fout-callback van kiesLogoBestand) de knop weer
  // vrijgeven midden in de snapshot/cart-add-flow.
  function bijwerkenToevoegenKnopStatus() {
    var knop = document.getElementById("studio-toevoegen");
    if (knop) {
      knop.disabled = state.logoBezigMetUploaden || state.bezigMetVerzenden;
    }
  }

  function toonFoutmelding(tekst) {
    var el = document.getElementById("studio-foutmelding");
    if (!el) {
      return;
    }
    if (!tekst) {
      el.hidden = true;
      el.textContent = "";
      return;
    }
    el.hidden = false;
    el.textContent = tekst;
  }

  function valideerVoorWinkelwagen() {
    if (!state.kleur || !state.reeks) {
      return "Kies eerst een kleur en een jaarreeks.";
    }
    // Fixronde 1, bevinding 2: defense-in-depth naast het blokkeren van de
    // knop zelf (bijwerkenToevoegenKnopStatus) -- ook hier weigeren als de
    // upload nog loopt, of als er wel een logo-afbeelding staat maar geen
    // logoUrl (upload is mislukt of nooit afgerond).
    if (state.logoBezigMetUploaden) {
      return "Je logo wordt nog geupload, wacht heel even.";
    }
    if (state.logoImg && !state.logoUrl) {
      return "Het uploaden van je logo is niet gelukt. Upload het opnieuw voor je bestelt.";
    }
    var heeftTekst = state.teksten.some(function (t) {
      return t && t.trim() !== "";
    });
    if (!heeftTekst && !state.logoUrl) {
      return "Vul minstens keuringstekst 1 in, of upload een logo.";
    }
    return null;
  }

  function afronden2(getal) {
    return Math.round(getal * 100) / 100;
  }

  function voegToeAanWinkelwagen(knop) {
    var gekozenVariant = document.querySelector('input[name="studio-aantal"]:checked');
    if (!gekozenVariant) {
      toonFoutmelding("Kies een aantal.");
      state.bezigMetVerzenden = false;
      bijwerkenToevoegenKnopStatus();
      return;
    }

    // trim() op alle tekstvelden bij het verzenden (fixronde 1, kleine
    // toevoeging): voorkomt lege-spaties-only waarden en trailing/leading
    // spaties in de winkelwagen-properties.
    var fd = new FormData();
    fd.append("id", gekozenVariant.value);
    fd.append("quantity", "1");
    fd.append("properties[Kleur]", state.kleur);
    fd.append("properties[Jaarreeks]", state.reeks);
    fd.append("properties[Keuringstekst 1]", (state.teksten[0] || "").trim());
    fd.append("properties[Keuringstekst 2]", (state.teksten[1] || "").trim());
    fd.append("properties[Keuringstekst 3]", (state.teksten[2] || "").trim());
    fd.append("properties[Tekst boven logo]", (state.tekstBoven || "").trim());
    fd.append("properties[Tekst rechts van logo]", (state.tekstRechts || "").trim());
    fd.append("properties[_LogoURL]", state.logoUrl || "");
    fd.append("properties[_LogoPositie]", JSON.stringify(logoPositieVoorProperty()));
    fd.append("properties[_TekstPositie]", JSON.stringify(tekstPositieVoorProperty()));
    fd.append("properties[_SnapshotURL]", state.snapshotUrl || "");

    fetch("/cart/add.js", { method: "POST", body: fd })
      .then(function (resp) {
        return resp.json().then(function (data) {
          return { ok: resp.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          toonFoutmelding((result.data && result.data.description) || "Toevoegen aan de winkelwagen is mislukt.");
          state.bezigMetVerzenden = false;
          bijwerkenToevoegenKnopStatus();
          return;
        }
        window.location = "/cart";
      })
      .catch(function () {
        toonFoutmelding("Toevoegen aan de winkelwagen is mislukt.");
        state.bezigMetVerzenden = false;
        bijwerkenToevoegenKnopStatus();
      });
  }

  function initGebeurtenissen() {
    var herprobeerKnop = document.getElementById("studio-canvas-herprobeer");
    if (herprobeerKnop) {
      herprobeerKnop.addEventListener("click", function () {
        toonCanvasFoutmelding(null);
        var key = state.kleur + "-" + state.reeks;
        delete ondergronden[key];
        ctx.clearRect(0, 0, CANVAS_MAAT, CANVAS_MAAT);
        ctx.fillStyle = "#eeeeee";
        ctx.fillRect(0, 0, CANVAS_MAAT, CANVAS_MAAT);
        laadOndergrond(state.kleur, state.reeks, teken, true);
      });
    }

    var kleurenGroep = document.querySelector(".studio-kleuren");
    if (kleurenGroep) {
      kleurenGroep.addEventListener("click", function (evt) {
        var knop = evt.target.closest(".studio-kleurbol");
        if (!knop) {
          return;
        }
        kleurenGroep.querySelectorAll(".studio-kleurbol").forEach(function (b) {
          b.classList.remove("is-actief");
        });
        knop.classList.add("is-actief");
        state.kleur = knop.dataset.kleur;
        teken();
      });
    }

    var reeksenGroep = document.querySelector(".studio-reeksen");
    if (reeksenGroep) {
      reeksenGroep.addEventListener("click", function (evt) {
        var knop = evt.target.closest(".studio-reeksknop");
        if (!knop) {
          return;
        }
        reeksenGroep.querySelectorAll(".studio-reeksknop").forEach(function (b) {
          b.classList.remove("is-actief");
        });
        knop.classList.add("is-actief");
        state.reeks = knop.dataset.reeks;
        teken();
      });
    }

    var snelkeuze = document.getElementById("studio-snelkeuze");
    var tekst1 = document.getElementById("studio-tekst-1");
    if (snelkeuze && tekst1) {
      snelkeuze.addEventListener("change", function () {
        if (snelkeuze.value) {
          tekst1.value = snelkeuze.value;
          state.teksten[0] = snelkeuze.value;
          teken();
        }
      });
    }

    [
      ["studio-tekst-1", 0],
      ["studio-tekst-2", 1],
      ["studio-tekst-3", 2],
    ].forEach(function (paar) {
      var el = document.getElementById(paar[0]);
      if (el) {
        el.addEventListener("input", function () {
          state.teksten[paar[1]] = el.value;
          teken();
        });
      }
    });

    var tekstBovenEl = document.getElementById("studio-tekst-boven");
    if (tekstBovenEl) {
      tekstBovenEl.addEventListener("input", function () {
        state.tekstBoven = tekstBovenEl.value;
        teken();
      });
    }

    var tekstRechtsEl = document.getElementById("studio-tekst-rechts");
    if (tekstRechtsEl) {
      tekstRechtsEl.addEventListener("input", function () {
        state.tekstRechts = tekstRechtsEl.value;
        teken();
      });
    }

    var logoInput = document.getElementById("studio-logo-input");
    if (logoInput) {
      logoInput.addEventListener("change", function (evt) {
        var bestand = evt.target.files && evt.target.files[0];
        if (bestand) {
          kiesLogoBestand(bestand);
        }
      });
    }

    var dropzone = document.getElementById("studio-dropzone");
    if (dropzone) {
      ["dragenter", "dragover"].forEach(function (soort) {
        dropzone.addEventListener(soort, function (evt) {
          evt.preventDefault();
          dropzone.classList.add("is-dragover");
        });
      });
      ["dragleave", "drop"].forEach(function (soort) {
        dropzone.addEventListener(soort, function (evt) {
          evt.preventDefault();
          dropzone.classList.remove("is-dragover");
        });
      });
      dropzone.addEventListener("drop", function (evt) {
        var bestand = evt.dataTransfer.files && evt.dataTransfer.files[0];
        if (bestand) {
          kiesLogoBestand(bestand);
        }
      });
    }

    var schaalSlider = document.getElementById("studio-logo-schaal");
    if (schaalSlider) {
      schaalSlider.addEventListener("input", function () {
        state.logoPos.schaal = Number(schaalSlider.value) / 100;
        klemLogoPositie();
        teken();
      });
    }

    // Verbetering B: de twee nieuwe schuifjes onder de keuringstekst-velden.
    // Beide herklemmen ook de tekstpositie: een groter/ruimer blok kan
    // buiten de middenvlak-cirkel vallen als state.tekstPos.y al aan de rand
    // van de klem stond, dus klemTekstPositie() opnieuw aanroepen na elke
    // wijziging (zelfde aanpak als schaalSlider hierboven bij het logo).
    var tekstGrootteSlider = document.getElementById("studio-tekst-grootte");
    if (tekstGrootteSlider) {
      tekstGrootteSlider.addEventListener("input", function () {
        state.tekstGrootte = Number(tekstGrootteSlider.value) / 100;
        klemTekstPositie();
        teken();
      });
    }

    var regelafstandSlider = document.getElementById("studio-tekst-regelafstand");
    if (regelafstandSlider) {
      regelafstandSlider.addEventListener("input", function () {
        state.regelafstand = Number(regelafstandSlider.value) / 100;
        klemTekstPositie();
        teken();
      });
    }

    // Slepen: pointer events op het canvas, werkt zo ook op touch
    // (touch-action: none staat in de CSS op #studio-canvas). Verbetering
    // A: naast het logo kan nu ook het keuringstekst-blok gepakt worden
    // (alleen verticaal). Tekst wordt als laatste getekend (zie teken()),
    // dus zit visueel bovenop het logo -- de hit-test controleert het
    // tekstblok daarom eerst.
    canvas.addEventListener("pointerdown", function (evt) {
      var punt = pointerNaarCanvas(evt);
      if (puntInTekstblok(punt)) {
        var rechthoekTekst = tekstRechthoek();
        slepen = { doel: "tekst", dy: punt.y - rechthoekTekst.cy };
        canvas.classList.add("is-slepen");
        canvas.setPointerCapture(evt.pointerId);
        return;
      }
      if (state.logoImg && puntInLogo(punt)) {
        var rechthoekLogo = logoRechthoek();
        slepen = { doel: "logo", dx: punt.x - rechthoekLogo.cx, dy: punt.y - rechthoekLogo.cy };
        canvas.classList.add("is-slepen");
        canvas.setPointerCapture(evt.pointerId);
      }
    });

    canvas.addEventListener("pointermove", function (evt) {
      if (!slepen) {
        return;
      }
      var punt = pointerNaarCanvas(evt);
      if (slepen.doel === "tekst") {
        state.tekstPos.y = (punt.y - slepen.dy) / CANVAS_MAAT;
        klemTekstPositie();
      } else {
        state.logoPos.x = (punt.x - slepen.dx) / CANVAS_MAAT;
        state.logoPos.y = (punt.y - slepen.dy) / CANVAS_MAAT;
        klemLogoPositie();
      }
      teken();
    });

    ["pointerup", "pointercancel"].forEach(function (soort) {
      canvas.addEventListener(soort, function () {
        slepen = null;
        canvas.classList.remove("is-slepen");
      });
    });

    var toevoegenKnop = document.getElementById("studio-toevoegen");
    if (toevoegenKnop) {
      toevoegenKnop.addEventListener("click", function () {
        var fout = valideerVoorWinkelwagen();
        if (fout) {
          toonFoutmelding(fout);
          return;
        }
        toonFoutmelding(null);
        // Eindfixronde, meelifter: via de state-vlag + bijwerkenToevoegenKnopStatus()
        // i.p.v. rechtstreeks toevoegenKnop.disabled zetten, zodat een
        // logo-upload die precies in deze verzending klaarkomt de knop niet
        // per ongeluk weer vrijgeeft (zie bijwerkenToevoegenKnopStatus()).
        state.bezigMetVerzenden = true;
        bijwerkenToevoegenKnopStatus();

        maakSnapshotBlob(function (blob) {
          // Fixronde 1, bevinding 5: canvas.toBlob kan null opleveren
          // (bijv. een tainted canvas of een browserfout). Zonder deze
          // check crashte uploadBestand op blob.name, met een permanent
          // geblokkeerde knop en geen melding.
          if (!blob) {
            toonFoutmelding("Snapshot maken is mislukt, probeer het nog eens.");
            state.bezigMetVerzenden = false;
            bijwerkenToevoegenKnopStatus();
            return;
          }
          uploadBestand(
            blob,
            function (snapshotUrl) {
              state.snapshotUrl = snapshotUrl;
              voegToeAanWinkelwagen(toevoegenKnop);
            },
            function (fout) {
              toonFoutmelding("Snapshot uploaden is mislukt: " + fout);
              state.bezigMetVerzenden = false;
              bijwerkenToevoegenKnopStatus();
            }
          );
        });
      });
    }
  }

  // Fixronde 1, bevinding 5: tekent de snapshot op een los, vast 600x600
  // offscreen-canvas (geen devicePixelRatio-schaling), in plaats van
  // rechtstreeks canvas.toBlob() op het zichtbare hiDPI-canvas aan te
  // roepen. Zonder dit leverde een Retina-scherm of telefoon een snapshot
  // van 1200-1800px op, wat nooit getest was en niet is wat taak 6
  // verwacht (een vaste 600x600 PNG). ctx wordt tijdelijk omgezet naar de
  // offscreen-context zodat teken() ongewijzigd hergebruikt kan worden.
  function maakSnapshotBlob(callback) {
    var snapshotCanvas = document.createElement("canvas");
    snapshotCanvas.width = CANVAS_MAAT;
    snapshotCanvas.height = CANVAS_MAAT;
    var snapshotCtx = snapshotCanvas.getContext("2d");

    var vorigeCtx = ctx;
    ctx = snapshotCtx;
    teken();
    ctx = vorigeCtx;

    snapshotCanvas.toBlob(function (blob) {
      callback(blob);
    }, "image/png");
  }

  function init() {
    canvas = document.getElementById("studio-canvas");
    if (!canvas) {
      return;
    }
    initCanvasHiDPI();
    initGebeurtenissen();
    // Defensief: de liquid-template zet de twee logo-tekstvelden al standaard
    // op disabled (IMPORTANT 4), maar dit houdt JS en markup expliciet in
    // sync, ook als iemand de template ooit zonder dat attribuut opnieuw
    // opbouwt.
    bijwerkenLogoTekstVeldenStatus();
    teken();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Voor Playwright-tests: state en teken() ook buiten de closure bereikbaar.
  // logoPositieVoorProperty/tekstPositieVoorProperty erbij (verbetering A) om
  // de winkelwagen-property-waarden rechtstreeks te kunnen controleren zonder
  // de hele cart/add.js-flow te hoeven doorlopen.
  window.STUDIO = {
    state: state,
    teken: teken,
    bijwerkenLogoTekstVeldenStatus: bijwerkenLogoTekstVeldenStatus,
    logoPositieVoorProperty: logoPositieVoorProperty,
    tekstPositieVoorProperty: tekstPositieVoorProperty,
  };
})();
